export const BRAND_PAGE_SOURCE = 'brand_page';
export const BRAND_PAGE_COLLECTION_SOURCE = 'brand_page_collection';

interface BrandPageCustomCollection {
  gtins: string[];
  title: string;
}

export interface BrandStorefrontModule {
  content_text: string;
  custom_collections?: BrandPageCustomCollection[];
  desktop_image_url: string;
  headline: string;
  mobile_image_url: string;
  video_url?: string;
}
